var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.billingUser || _vm.purchaseOption
    ? _c("SoliAvatarBtn", {
        attrs: {
          title: _vm.purchaseOption?.name,
          icon: "wallet",
          subtitleBottom: `Paid for by ${_vm.billingUser?.name}`,
          blue: "",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }